import { navLinkStyles } from "@/react/components/shared/ModalsV2/FullScreenModal/components/HeaderNav";
import { classNames } from "@/react/helpers/twMergeWithCN";

interface NavItemProps {
  active?: boolean;
  disabled?: boolean;
  label: string;
  onClick?: () => void;
}

export const NavItem = ({ active, disabled, label, onClick }: NavItemProps) => {
  const handleClick = () => !disabled && onClick && onClick();

  return (
    <li>
      <button
        className={classNames(navLinkStyles.className, {
          [navLinkStyles.activeClassName]: active,
          "hover:text-default focus:text-default cursor-auto opacity-50":
            !active && disabled,
        })}
        onClick={handleClick}
        onKeyDown={(e: React.KeyboardEvent<HTMLButtonElement>) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleClick();
          }
        }}
        type="button"
      >
        {label}
      </button>
    </li>
  );
};
